import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppService } from '../../service/app.service';
import { RisorseService } from '../../service/risorse.service';

@Injectable()
export class HttpHeaderInterceptor implements HttpInterceptor {
  constructor(
    private appService: AppService,
    private risorseService: RisorseService,
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    let matricolaRisorsa = this.risorseService.risorsa.risorsa;
    request = request.clone({
      setHeaders: {
        'IdRisorsa': matricolaRisorsa ?? "",
        'Timestamp': this.appService.timestamp ?? "",
      }
    });

    return next.handle(request);
  }
}
